import { useEffect, useState } from 'react';
import useDebounce from '../../../core/hooks/useDebounce';
import coursesService from '../../Courses/components/CardList/logic/useCardListService';
import {useQuery } from 'react-query';
import quizManagementService from '../logic/quizManagementService';



const useQuizPreview = (id) => {
  
  const [questions, setQuestions] = useState([])
  const [searchCrouseText, setSearchCrouseText] = useState("");
  const {debouncedValue } = useDebounce(searchCrouseText, 1000);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [quizName, setQuizName] = useState("");







  const { data:formData, isLoading:isDataLoading, error:dataError,refetch:refetchFormData } = useQuery(
    ["form"],
    () => quizManagementService.getOneForm(id),
    {
      initialData: {
        data: { data: [], meta: { hasPrevious: false, hasNext: false } },
      },
      keepPreviousData: true, 
      refetchOnWindowFocus: false,
    },
  );



  const { data, isLoading, error, refetch } = useQuery(
    ["CoursesData", debouncedValue],
    () => coursesService.getCoursesData({filterOptions: JSON.stringify({searchText:searchCrouseText})}),
    {
      initialData: {
        data: { data: [], meta: { hasPrevious: false, hasNext: false } },
      },
      keepPreviousData: true, 
      refetchOnWindowFocus: false,
    },
  );

  useEffect(()=>{
    const foundCourse = data?.data?.data.find(course => course.id === formData.data.courseId)
    setSelectedCourse(foundCourse?.title)
    setQuestions(changeFormToQuiz(formData.data))
    setQuizName(formData.data.formName)
  },[formData])



  const changeFormToQuiz = (form) => {


    const questions = form?.fields?.map((field) => {
      let fieldType = "";
      switch (field.fieldType) {
        case "textarea":
          fieldType = "Textarea";
          break;
        case "checkbox":
          fieldType = "SelectMultiple";
          break;
        case "radio":
          fieldType = "SelectSingle";
          break;
        default:
          fieldType = "";
      }
  
      const options = fieldType !== "Textarea"? 
         field.questions[0]?.options?.map((option) => ({
            optionId:option.id,
            label :option.optionLabel,
            value:  !isNaN(parseFloat(option.optionValue)) ? parseFloat(option.optionValue) : option.optionValue,
            description: option.description,
            isCorrect: option.isCorrect,
            score: option.score,
          })) || []  :""

      if( fieldType === "Textarea") {return {formId:form.id,fieldId:field.id,questionId:field.questions[0]?.id,typeOfQuestion: fieldType,optionId:field.questions[0]?.options[0]?.id,
       question: field.questions[0]?.questionText,description:field.questions[0]?.options[0]?.description,answer:field.questions[0]?.options[0]?.optionValue }}
      return  {formId:form.id,fieldId:field.id,questionId:field.questions[0]?.id,typeOfQuestion: fieldType, question: field.questions[0]?.questionText,options };
    });
  
     return questions
  }

 



  const getQuestionData = (questionNumber, data) => {
    if (questionNumber >= 0 && data) {
      let questionsUpdate = [...questions];
      questionsUpdate[questionNumber] = { ...questionsUpdate[questionNumber], ...data }
      setQuestions(questionsUpdate);
    }
  }


  return {
    questions,
    getQuestionData,
    quizName,
    selectedCourse,
  };
};

export default useQuizPreview;
